var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCareTeamContact = function SvgCareTeamContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F2ED",
    d: "M58.367 1.133L56.519 0l-5.643 8.021 2.147 1.322c11.096 6.83 17.46 17.091 17.46 28.149 0 11.09-6.331 21.35-17.374 28.15l-2.117 1.303L56.494 75l1.873-1.149C68.465 67.654 80.5 56.316 80.5 37.492c0-18.823-12.035-30.162-22.133-36.36zm-30.391 8.21c-11.095 6.832-17.46 17.092-17.46 28.149 0 11.09 6.332 21.35 17.377 28.15l2.117 1.303-5.504 8.054-1.87-1.147C12.538 67.656.5 56.317.5 37.492.5 18.669 12.537 7.33 22.633 1.132L24.481 0l5.644 8.021-2.15 1.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D0C5",
    fillRule: "nonzero",
    d: "M43.25 47.813v-4.126c0-.386-.3-.687-.688-.687h-4.124c-.387 0-.688.3-.688.688v4.124c0 .387.3.688.688.688h4.124c.387 0 .688-.3.688-.688zm5.5-14.438c0-3.932-4.125-6.875-7.82-6.875-3.502 0-6.123 1.504-7.971 4.576a.676.676 0 0 0 .172.903l2.836 2.148a.661.661 0 0 0 .408.129.681.681 0 0 0 .537-.258c1.01-1.289 1.44-1.676 1.848-1.977.365-.257 1.074-.515 1.847-.515 1.375 0 2.643.88 2.643 1.826 0 1.117-.58 1.676-1.89 2.277-1.526.688-3.61 2.471-3.61 4.555v.773c0 .387.3.688.688.688h4.124c.387 0 .688-.3.688-.688 0-.494.623-1.546 1.633-2.126 1.633-.924 3.867-2.17 3.867-5.436zM57 37.5C57 46.61 49.61 54 40.5 54S24 46.61 24 37.5 31.39 21 40.5 21 57 28.39 57 37.5z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCareTeamContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/care-team-contact.93bd81e9.svg";
export { ForwardRef as ReactComponent };